import styled from 'styled-components';
import DatePicker from 'react-datepicker';

require('react-datepicker/dist/react-datepicker.css');

export const Container = styled.div``;

export const DateField = styled(DatePicker)`
  width: ${({ fieldWidth }) => `${fieldWidth}%`};
`;
